import { createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-63ff60a1")

_pushScopeId("data-v-63ff60a1")
const _hoisted_1 = { class: "flex flex--v flex--valign-c flex--gap-30" }
const _hoisted_2 = { class: "flex flex--valign-c flex--halign-c flex--gap-10" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "text text--size-14 text--primary-b" }, "•", -1)
const _hoisted_4 = { class: "text text--size-18 text--semi-bold text--primary-b text--uppercase" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("No title")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text text--size-14 text--primary-b" }, "•", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("No Content")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_Plane = _resolveComponent("Plane")

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal-wrapper" }, [
    _createVNode(_Transition, {
      name: "modal-close-transition",
      onAfterLeave: _ctx.onAfterLeave
    }, {
      default: _withId(() => [
        (_ctx.visible)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "modal-wrapper",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
            }, [
              _createVNode(_component_Plane, { class: "modal-plane" }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createVNode("span", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "title", {}, () => [
                          _hoisted_5
                        ], {}, true)
                      ]),
                      _hoisted_6
                    ]),
                    _renderSlot(_ctx.$slots, "content", {}, () => [
                      _hoisted_7
                    ], {}, true),
                    _createVNode("div", {
                      class: "modal-plane-buttons flex flex--valign-c flex--gap-15 flex--halign-c",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
                    }, [
                      _renderSlot(_ctx.$slots, "buttons", {}, () => [
                        _createVNode(_component_GenericButton, {
                          title: _ctx.$trans('acp.close'),
                          circular: true,
                          onClick: _withModifiers(_ctx.close, ["stop"])
                        }, null, 8, ["title", "onClick"])
                      ], {}, true)
                    ])
                  ])
                ]),
                _: 3
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onAfterLeave"])
  ]))
})